import { createContext, useState } from "react";

const ReguaCobrancaContext = createContext();

const ReguaCobrancaContextProvider = ({ children }) => {
  const [checkBeforeExpiration, setCheckBeforeExpiration] = useState(false);
  const [checkOnExpiration, setCheckOnExpiration] = useState(false);
  const [checkPendency, setCheckPendency] = useState(false);
  const [checkWarningSuspension, setCheckWarningSuspension] = useState(false);
  const [checkSuspension, setCheckSuspension] = useState(false);
  const [checkToThank, setCheckToThank] = useState(false);

  const [daysBeforeExpiration, setDaysBeforeExpiration] = useState("0");
  const [daysPendency, setDaysPendency] = useState("0");
  const [daysWarningSuspension, setDaysWarningSuspension] = useState("0");
  const [daysSuspension, setDaysSuspension] = useState("0");

  const [mailBeforeExpiration, setMailBeforeExpiration] = useState(null);
  const [mailOnExpiration, setMailOnExpiration] = useState(null);
  const [mailPendency, setMailPendency] = useState(null);
  const [mailWarningSuspension, setMailWarningSuspension] = useState(null);
  const [mailSuspension, setMailSuspension] = useState(null);
  const [mailToThank, setMailToThank] = useState(null);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [mailsModels, setMailsModels] = useState([]);

  return (
    <ReguaCobrancaContext.Provider
      value={{
        checkBeforeExpiration,
        setCheckBeforeExpiration,
        checkOnExpiration,
        setCheckOnExpiration,
        checkPendency,
        setCheckPendency,
        checkWarningSuspension,
        setCheckWarningSuspension,
        checkSuspension,
        setCheckSuspension,
        checkToThank,
        setCheckToThank,

        daysBeforeExpiration,
        setDaysBeforeExpiration,
        daysPendency,
        setDaysPendency,
        daysWarningSuspension,
        setDaysWarningSuspension,
        daysSuspension,
        setDaysSuspension,

        mailBeforeExpiration,
        setMailBeforeExpiration,
        mailOnExpiration,
        setMailOnExpiration,
        mailPendency,
        setMailPendency,
        mailWarningSuspension,
        setMailWarningSuspension,
        mailSuspension,
        setMailSuspension,
        mailToThank,
        setMailToThank,

        errors,
        setErrors,
        loading,
        setLoading,
        mailsModels,
        setMailsModels,
      }}
    >
      {children}
    </ReguaCobrancaContext.Provider>
  );
};

export { ReguaCobrancaContext, ReguaCobrancaContextProvider };
